import axios from 'axios';
import {
  SPOR_TOTO_PLAY_REQUEST,
  SPOR_TOTO_PLAY_SUCCESS,
  SPOR_TOTO_PLAY_FAILURE,
  SPOR_TOTO_GET_EVENTS_REQUEST,
  SPOR_TOTO_GET_EVENTS_SUCCESS,
  SPOR_TOTO_GET_EVENTS_FAILURE,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE,
  SPOR_TOTO_TOGGLE_SELECTION,
  SPOR_TOTO_REMOVE_SELECTIONS,
  SPOR_TOTO_RANDOM_SELECTIONS,
  SPOR_TOTO_SET_SELECTIONS,
  SPOR_TOTO_SET_POPULAR_SELECTIONS,
  SPOR_TOTO_GET_POPULAR_SELECTIONS,
  SPOR_TOTO_RESULT_REQUEST,
  SPOR_TOTO_RESULT_SUCCESS,
  SPOR_TOTO_RESULT_FAILURE,
  SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST,
  SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS,
  SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE,
  SPOR_TOTO_COUPONS_REQUEST,
  SPOR_TOTO_COUPONS_RESET,
  SPOR_TOTO_COUPONS_SUCCESS,
  SPOR_TOTO_COUPONS_FAILURE,
  SPOR_TOTO_CANCEL_COUPON_REQUEST,
  SPOR_TOTO_CANCEL_COUPON_SUCCESS,
  SPOR_TOTO_CANCEL_COUPON_FAILURE,
  SPOR_TOTO_COUPON_DETAIL_REQUEST,
  SPOR_TOTO_COUPON_DETAIL_SUCCESS,
  SPOR_TOTO_COUPON_DETAIL_FAILURE,
  SPOR_TOTO_COUPON_EARNINGS_REQUEST,
  SPOR_TOTO_COUPON_EARNINGS_SUCCESS,
  SPOR_TOTO_COUPON_EARNINGS_FAILURE,
  GET_SPOR_TOTO_COUPON_INFO_REQUEST,
  GET_SPOR_TOTO_COUPON_INFO_SUCCESS,
  GET_SPOR_TOTO_COUPON_INFO_FAILURE,
  SPOR_TOTO_SAVE_REQUEST,
  SPOR_TOTO_SAVE_SUCCESS,
  SPOR_TOTO_SAVE_FAILURE,
  GET_SPOR_TOTO_HISTORY_LIST_REQUEST,
  GET_SPOR_TOTO_HISTORY_LIST_SUCCESS,
  GET_SPOR_TOTO_HISTORY_LIST_FAILURE,
  GET_SPOR_TOTO_COUNT_DOWN,
  GET_SPOR_TOTO_COUNT_DOWN_SUCCESS,
  GET_SPOR_TOTO_COUNT_DOWN_FAILURE,

  SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST,
  SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS,
  SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE,

  SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST,
  SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS,
  SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE,


} from 'Store/constants';
import { updateUserBalance } from 'Store/actions';
import { openModal } from './modalActions';
import { trackSporToto } from 'Utils/analytics';
import { isSporTotoV2Enabled, encodeSporTotoRequest } from 'Utils/sporTotoV2';

export const getSporTotoCouponDetails = couponId => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_COUPON_DETAIL_REQUEST
    });

    const res = await axios.get('/sportoto/couponNgDetailsWithCurrentResults?couponId=' + couponId);

    dispatch({
      type: SPOR_TOTO_COUPON_DETAIL_SUCCESS,
      payload: res.data
    });

    return res?.data;
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_COUPON_DETAIL_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const playSporTotoCoupon = (columns, multiplier, totalAmount, columnCount) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SPOR_TOTO_PLAY_REQUEST
    });

    const requestBody = {
      columns,
      multiplier,
      channel: 'WEB'
    };

    let res;

    if (isSporTotoV2Enabled()) {
      res = await axios.post('/sportoto/v2/coupons/play', {
        encodedRequest: encodeSporTotoRequest(requestBody)
      });
    } else {
      res = await axios.post('/sportoto/coupons/play', requestBody);
    }
    const { balance, couponId } = res.data;
    
    const sporTotoEvents = getState().sporToto.sporTotoCommonData.eventsData.events.gameCycleEntityModel.eventVOs;
    const sportTotoColumns = getState().sporToto.sporTotoSelections;

    const trackProducts = [];
    const columnKeys = Object.keys(sportTotoColumns);
    for (let index = 0; index < columnKeys.length; index++) {
      const column = sportTotoColumns[columnKeys[index]];
      column.forEach(playedEvent=> {
        const foundEventIndex = trackProducts.findIndex(item => item.id === playedEvent.eventId);
        // if find event in coupon, add column
        if (foundEventIndex > -1) {
          trackProducts[foundEventIndex].columns.push({
            column: columnKeys[index],
            odds: playedEvent.odds
          });
        } else {
          // if can't find event in coupon, create a new event and add column
          trackProducts.push({
            ...sporTotoEvents.find(item => item.id === playedEvent.eventId),
            columns: [{
              column: columnKeys[index],
              odds: playedEvent.odds
            }]
          });
        }
      });
    }

    const trackCoupon = {
      id: couponId,
      revenue: balance,
      products: trackProducts,
      totalAmount: totalAmount
    };

    trackSporToto(trackCoupon);

    dispatch({
      type: SPOR_TOTO_PLAY_SUCCESS,
      payload: { ...res.data, columns, multiplier, totalAmount, columnCount }
    });

    dispatch(removeSporTotoSelections('all'));
    dispatch(openModal('sporTotoPlayCouponSuccessModal'));
    dispatch(updateUserBalance());

  } catch (e) {
    dispatch({
      type: SPOR_TOTO_PLAY_FAILURE,
      payload: e.response && e.response.data
    });
    try {
      const { response: { data: { code } } } = e;
      if (code === 4011) {
        dispatch(openModal('sporTotoPlayBalanceNotEnoughModal'));
      } else {
        throw new Error('Code is not 4011');
      }
    } catch (e) {
      dispatch(openModal('sporTotoPlayErrorModal'));
    }
  }
};

export const cancelSporTotoCoupon = (couponIdRequest, ticketIdRequest, status) => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_CANCEL_COUPON_REQUEST
    });

    const res = await axios.post('/sportoto/coupons/cancel', { coupons: [{ couponId: couponIdRequest, ticketId: ticketIdRequest }] });

    dispatch({
      type: SPOR_TOTO_CANCEL_COUPON_SUCCESS,
      payload: res.data
    });

    if (res.data.coupons && res.data.coupons.length > 0 && !res.data.coupons[0].isCancelled) {
      dispatch(openModal('sporTotoCancelCouponInfoModal'));
    } else {
      dispatch(getSporTotoCoupons(status));
    }
    dispatch(updateUserBalance());
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_CANCEL_COUPON_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoEvents = () => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_GET_EVENTS_REQUEST
    });

    const res = await axios.get('/sto/programs/active');
    dispatch({
      type: SPOR_TOTO_GET_EVENTS_SUCCESS,
      payload: res.data
    });
 
    dispatch(getSporTotoEventsPlayRatioList(res.data.gameCycleEntityModel.gcNo));
    return res?.data;

   
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_GET_EVENTS_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoResults = (gameNo = 4) => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_RESULT_REQUEST
    });

    const res = await axios.get('/sto/programs/drawinfo/q3?gameNo=' + gameNo);
    dispatch({
      type: SPOR_TOTO_RESULT_SUCCESS,
      payload: res.data
    });
    return res?.data;
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_RESULT_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoResultsByWeekly = (gameNo = 4, gcNo) => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST
    });

    const res = await axios.get(`/sto/programs/drawinfo/q4?gameNo=${gameNo}&gcNo=${gcNo}` );
    dispatch({
      type: SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoEventsPlayRatioList = gcNo => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST
    });

    const res = await axios.get('/sto/playratio?gcNo=' + gcNo);

    dispatch({
      type: SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const sporTotoToggleSelection = (columnName, id, oddType, index) => dispatch => {
  dispatch({
    type: SPOR_TOTO_TOGGLE_SELECTION,
    payload: { columnName, id, oddType, index: index - 1 }
  });
};

export const setSportotoSelections = sportotoSelections => dispatch => {
  dispatch({
    type: SPOR_TOTO_SET_SELECTIONS,
    payload: { selections: sportotoSelections }
  });
};

export const removeSporTotoSelections = columnName => dispatch => {
  dispatch({
    type: SPOR_TOTO_REMOVE_SELECTIONS,
    payload: columnName
  });
};

export const setRandomSelections = (columnName, events, callback) => dispatch => {
  dispatch({
    type: SPOR_TOTO_RANDOM_SELECTIONS,
    payload: { columnName, events }
  });
  if (callback) {
    dispatch(callback());
  }
};

export const setPopularSelections = (id, odd) => dispatch => {
  dispatch({
    type: SPOR_TOTO_SET_POPULAR_SELECTIONS,
    payload: { id, odd }
  });
};

export const getPopularSelections = (columnName, callback) => (dispatch, getState) => {
  dispatch({
    type: SPOR_TOTO_GET_POPULAR_SELECTIONS,
    payload: { columnName, selections: getState().sporToto.sporTotoPopularSelections.selections }
  });
  if (callback) {
    dispatch(callback());
  }
};

// export const getSporTotoCoupons = status => async dispatch => {
//   try {
//     dispatch({
//       type: SPOR_TOTO_COUPONS_REQUEST
//     });

//     const res = await axios.get('/sportoto/couponsng?status=' + status);
//     dispatch({
//       type: SPOR_TOTO_COUPONS_SUCCESS,
//       payload: { ...res.data, activeTab: status },
//     });

//   } catch (e) {
//     dispatch({
//       type: SPOR_TOTO_COUPONS_FAILURE,
//       payload: e.response && e.response.data
//     });
//   }
// };

export const getSporTotoCoupons = (status, offset) => async dispatch => {
  try {
    if (offset === 0 || offset === undefined || offset === null) {
      dispatch({
        type: SPOR_TOTO_COUPONS_RESET,
      });
    } else {
      dispatch({
        type: SPOR_TOTO_COUPONS_REQUEST,
      });
    }

    const res = await axios.get(`/sportoto/v3/coupons?offset=${offset ? offset : 0}&status=` + status);

    if (res?.data?.error) {
      throw res.data.error;
    }

    dispatch({
      type: SPOR_TOTO_COUPONS_SUCCESS,
      payload: { ...res.data.body, activeTab: status },
    });
  } catch (error) {
    dispatch({
      type: SPOR_TOTO_COUPONS_FAILURE,
      payload: { error: error || 'Seçtiğin kriterde kuponun bulunmuyor', activeTab: status },
    });
  }
};


export const getSporTotoCouponEarnings = couponId => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_COUPON_EARNINGS_REQUEST
    });

    const res = await axios.get('/sportoto/getCouponEarnings?couponId=' + couponId);

    dispatch({
      type: SPOR_TOTO_COUPON_EARNINGS_SUCCESS,
      payload: res.data
    });

  } catch (e) {
    dispatch({
      type: SPOR_TOTO_COUPON_EARNINGS_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoCouponInfo = (generalId, modalName) => async dispatch => {
  try {
    
    dispatch({
      type: GET_SPOR_TOTO_COUPON_INFO_REQUEST
    });
    
    const res = await axios.get('/sportoto/coupons?couponIds=' + generalId);
    
    dispatch({
      type: GET_SPOR_TOTO_COUPON_INFO_SUCCESS,
      payload: res.data.coupons[0],
    });
    
    dispatch(openModal(modalName));
  } catch (e) {
    dispatch({
      type: GET_SPOR_TOTO_COUPON_INFO_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const saveSporTotoCoupon = (columns, multiplier) => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_SAVE_REQUEST
    });

    const requestBody = {
      columns,
      multiplier,
      channel: 'WEB'
    };

    let res;

    if (isSporTotoV2Enabled()) {
      res = await axios.post('/sportoto/v2/coupons/saved', {
        encodedRequest: encodeSporTotoRequest(requestBody)
      });
    } else {
      res = await axios.post('/sportoto/coupons/saved', requestBody);
    }

    dispatch({
      type: SPOR_TOTO_SAVE_SUCCESS,
      payload: { ...res.data, columns, multiplier }
    });
    dispatch(openModal('savedSporTotoCoupon'));
    return { success: true };
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_SAVE_FAILURE,
      payload: e.response && e.response.data
    });
    dispatch(openModal('sporTotoSaveErrorModal'));
    return { success: false };
  }
};


export const getSporTotoWeeklyHistoryList = () => async dispatch => {
  try {
    
    dispatch({
      type: GET_SPOR_TOTO_HISTORY_LIST_REQUEST
    });
    const res = await axios.get('/sto/programs/drawinfo/q3/history?offset=0&pageSize=20');
    dispatch({
      type: GET_SPOR_TOTO_HISTORY_LIST_SUCCESS,
      payload: res.data,
    });

    return res?.data;
    
  } catch (e) {
    dispatch({
      type: GET_SPOR_TOTO_HISTORY_LIST_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const getSporTotoCountDown = () => async dispatch => {
  try {
    dispatch({
      type: GET_SPOR_TOTO_COUNT_DOWN
    });
    
    const res = await axios.get('/sto/programs/drawinfo/q3/counter');

    dispatch({
      type: GET_SPOR_TOTO_COUNT_DOWN_SUCCESS,
      payload: res.data
    });
    
  } catch (e) {
    dispatch({
      type: GET_SPOR_TOTO_COUNT_DOWN_FAILURE,
      payload: e.response && e.response.data
    });
  }
};

export const deleteSporTotoSavedCoupon = couponId => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST,
    });

    const res = await axios.delete(`/sportoto/coupons/saved/${couponId}`);

    dispatch({
      type: SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE,
      payload: e.response && e.response.data,
    });
    throw e;
  }
};

export const updateSporTotoSavedCoupon = (couponId, payload) => async dispatch => {
  try {
    dispatch({
      type: SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST,
    });

    let res;

    if (isSporTotoV2Enabled()) {
      res = await axios.put(`/sportoto/v2/coupons/saved/${couponId}`, {
        encodedRequest: encodeSporTotoRequest(payload)
      });
    } else {
      res = await axios.put(`/sportoto/coupons/saved/${couponId}`, payload);
    }

    dispatch({
      type: SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS,
      payload: res.data,
    });

    dispatch(removeSporTotoSelections('all'));
    return res.data;
  } catch (e) {
    dispatch({
      type: SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE,
      payload: e.response && e.response.data,
    });
    dispatch(openModal('sporTotoSaveErrorModal'));
    throw e;
  }
};

